export const ds_SocialMediaFeedBlock_Entry = `
    fragment ds_SocialMediaFeedBlock_Entry on ds_SocialMediaFeedBlock_Entry {
        id
        canonicalUid
        socialMediaFeed_TopSpacing
        socialMediaFeed_FullWidthBackground
        socialMediaFeed_ContainerWidth
        socialMediaFeed_ColorTheme
        socialMediaFeed_ColorPalette

        socialMediaFeed_Subheading
        socialMediaFeed_HeadingPosition
        socialMediaFeed_Heading
        socialMediaFeed_BodyText

        socialMediaFeed_SpaceBetweenImages
        socialMediaFeed_SocialFeedStyle
        socialMediaFeed_SocialFeedLayout
        socialMediaFeed_ShowCommentsLikes
        socialMediaFeed_LinkPosts
        socialMediaFeed_Carousel

        socialMediaFeed_Integration {
            integration
            socialFeeds
        }
    }
`